import styled from 'styled-components';
import { LazyFacade } from './LazyFacade.js';
import { jsx } from 'react/jsx-runtime';
function VideoPlayer({
  src,
  thumbnailUrl,
  thumbnailAlt,
  autoplay,
  hasLightbox
}) {
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsx(Content, {
      children: /*#__PURE__*/jsx(LazyFacade, {
        mediaUrl: src,
        thumbnailUrl: thumbnailUrl,
        thumbnailAlt: thumbnailAlt,
        autoplay: autoplay,
        hasLightbox: hasLightbox
      })
    })
  });
}
const Content = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
`;

// padding-top: 16:9 Aspect Ratio (divide 9 by 16 = 0.5625)
const Container = styled.div`
  display: block;
  padding-top: 56.25%;
  position: relative;
  height: 100%;
`;
export { VideoPlayer };
//# sourceMappingURL=VideoPlayer.js.map
